import React from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";

import Sidebar from "components/sidebar";
import Footer from "components/footer/Footer";

import routes from "routes.js";
import Navbar from "components/navbar/NavbarOrange";
import mitaxi from 'assets/img/logo_mitaxi.png';

export default function Admin(props) {
  // const { ...rest } = props;
  const location = useLocation();
  const [open, setOpen] = React.useState(false);
  const [currentRoute, setCurrentRoute] = React.useState("Main Dashboard");
  const [currentLoc, setCurrentLoc] = React.useState("default");
 

  React.useEffect(() => {
    window.addEventListener("resize", () =>
      window.innerWidth < 1200 ? setOpen(false) : setOpen(true)
    );
  }, []);
  React.useEffect(() => {
    getActiveRoute(routes);
  }, [location.pathname]);

  const getActiveRoute = (routes) => {
    let activeRoute = "Main Dashboard";
    for (let i = 0; i < routes.length; i++) {
      if (
        window.location.href.indexOf(
          routes[i].layout + "/" + routes[i].path
        ) !== -1
      ) {
        setCurrentRoute(routes[i].name);
        setCurrentLoc(routes[i].path)
      }
    }
    return activeRoute;
  };
  // const getActiveNavbar = (routes) => {
  //   let activeNavbar = false;
  //   for (let i = 0; i < routes.length; i++) {
  //     if (
  //       window.location.href.indexOf(routes[i].layout + routes[i].path) !== -1
  //     ) {
  //       return routes[i].secondary;
  //     }
  //   }
  //   return activeNavbar;
  // };
  const getRoutes = (routes) => {
    return routes.map((prop, key) => {
      if (prop.layout === "/admin") {
        return (
          <Route path={`/${prop.path}`} element={prop.component} key={key} />
        );
      } else {
        return null;
      }
    });
  };

  document.documentElement.dir = "ltr";
  return (
    <div className="flex h-full w-full">
      <Sidebar open={open} onClose={() => setOpen(false)} />
      {/* Navbar & Main Content */}
      <div className="h-full w-full bg-lightPrimary dark:!bg-navy-900">
        {/* Main Content */}
        <main
          className={`mx-[12px] h-full flex-none transition-all md:pr-2 xl:ml-[313px]`}
        >
          {/* Routes */}
          <div className="h-full">
            <Navbar
              onOpenSidenav={() => setOpen(!open)}
              logoText={"Horizon UI Tailwind React"}
              brandText={currentRoute}
              activeRoute={currentLoc}
              // secondary={getActiveNavbar(routes)}
              // {...rest}
            />
             { !open && (
                <div className="flex items-center justify-center h-full mt-2">
                  <img src={mitaxi} alt="logo" />
                </div>
              ) }
            <div className="pt-5s mx-auto mb-auto h-full min-h-[84vh] p-2 md:pr-2">
              <Routes >
                {getRoutes(routes)}
                
                <Route
                  path="/"
                  element={<Navigate to="/admin/default" replace />}
                />
              </Routes>
            </div>
            <div className="p-3">
              <Footer />
            </div>
          </div>
        </main>
      </div>
    </div>
  );
}
